// RTK have it's own actions. These action creaters are specifically for sagas
import { createAction } from '@reduxjs/toolkit';
import { PermissionSet, Role } from 'api/models';
import { Minutes } from 'components/organisms/user-capacity/types';
import { UserCreationProps } from 'contexts/project-creation';
import { Member } from './api';

interface GetProjectMembersPayload {
  projectId: number;
}

interface Callback {
  (data: any): void;
}

export const getProjectMembers = createAction<GetProjectMembersPayload>(
  'members/saga/get-project-members',
);

export const createMember = createAction<{
  data: UserCreationProps;
  successCallback?: Callback;
  failureCallback?: Callback;
}>('members/saga/create-account-member');

export const getMembers = createAction('members/saga/get-members');

export interface MemberManagementPayload {
  userId: number;
  handleSuccess?(): void;
  handleFailure?(): void;
}
export const deactivateMemberAction = createAction<MemberManagementPayload>(
  '@@members/deactivateMember',
);
export const reactivateMemberAction = createAction<MemberManagementPayload>(
  '@@members/reactivateMember',
);

export interface InviteOrUpdateMembersPayload {
  data: {
    user: {
      userId: number;
      role: AtLeast<Role, 'roleId'>;
      defaultCapacity: boolean;
      capacityMinutes: Minutes;
    };
    permissionSet: Pick<PermissionSet, 'permissionSetId'>;
  }[];
  role: {
    value: string;
    isNew: boolean;
  };
  handleSuccess?(data: Member): void;
  handleFailure?(data?: Member[]): void;
  handleAlways?(): void;
}

export interface ReInviteMembers {
  data: {
    user: {
      emailId: string;
      role: AtLeast<Role, 'roleId'>;
      defaultCapacity: boolean;
      capacityMinutes: Minutes;
    };
    permissionSet: Pick<PermissionSet, 'permissionSetType'>;
  }[];
  handleSuccess?(): void;
  handleFailure?(): void;
  handleAlways?(): void;
}
export const inviteMembersAction = createAction<InviteOrUpdateMembersPayload>(
  '@@members/inviteMembers',
);

export const reinviteMembersAction = createAction<ReInviteMembers>(
  '@@members/reinviteMembers',
);

export const updateMemberAction = createAction<InviteOrUpdateMembersPayload>(
  '@@members/updateMember',
);
